import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { compose } from 'recompose'

import {
  organizations as organizationsApi,
  tasks as tasksApi,
  blobs as blobsApi
} from 'redux/modules/api'
import { notification, modal, setPage, logError } from 'redux/modules/app'
import { ORGANIZATION_HIERARCHY, ROLES } from 'constants/enums'
import { updateScheme } from 'models/organization'
import appConfig from 'config'
import areAllSelectedForBulk from '../../../../redux/selectors/organizations/areAllSelectedForBulk'
import mapOrganizationsForBulk from '../../../../redux/selectors/organizations/mapOrganizationsForBulk'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      withRouter,
      connect(state => ({
          activeOrganization: state.auth.organization,
          activeOrganizationId: state.auth.organization.id,
          user: state.auth.user,
          organizations: state.api.organizations,
          leaders: state.api.leaders,
          local: {
            tasks: state.api.tasks.registrationAwardUnits
          },
          commonLimit: state.app.commonLimit,
          selectableOrganizationIds: config.list ? mapOrganizationsForBulk(state) : [],
          areAllOrganizationsSelected: config.list ? areAllSelectedForBulk(state) : false
        }),
        {
          ...organizationsApi,
          notification,
          modal,
          push,
          setPage,
          logError,
          uploadImageBlob: blobsApi.uploadImageBlob,
          getTasksRegistrationAwardUnits: tasksApi.registrationAwardUnits
            .getTasksRegistrationAwardUnits,
          getTasksOverview: tasksApi.overview.getTasksOverview,
          bulkSelectOrganizations: organizationsApi.toggleOrganizationsAllSelected
        }
      )
    )

    class Organizations extends Component {
      static propTypes = {
        // setPage: PropTypes.func.isRequired,
        decoFilter: PropTypes.string,
        decoOrganizationHierarchyLevel: PropTypes.number,
        decoOrganizationId: PropTypes.number,
        activeOrganization: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        activeOrganizationId: PropTypes.number.isRequired,
        organizations: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        leaders: PropTypes.object.isRequired,
        params: PropTypes.object,
        route: PropTypes.object,
        local: PropTypes.object,
        notification: PropTypes.func.isRequired,
        uploadImageBlob: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        getOrganization: PropTypes.func.isRequired,
        getOrganizations: PropTypes.func.isRequired,
        getOrganizationCodeList: PropTypes.func.isRequired,
        getOrganizationLeaders: PropTypes.func.isRequired,
        checkOrganization: PropTypes.func.isRequired,
        approveAwardUnit: PropTypes.func.isRequired,
        exportOrganizations: PropTypes.func.isRequired,
        changeOrganisationMode: PropTypes.func.isRequired,
        updateMyOrganization: PropTypes.func.isRequired,
        makeLeadCoordinator: PropTypes.func.isRequired,
        getTasksRegistrationAwardUnits: PropTypes.func.isRequired,
        setOrganizationsParams: PropTypes.func.isRequired,
        setOrganizationsFilter: PropTypes.func,
        removeOrganization: PropTypes.func.isRequired,
        getTasksOverview: PropTypes.func.isRequired,
        changeOrganizationAuthorizingContact: PropTypes.func.isRequired,
        removeOrganizationCoordinator: PropTypes.func.isRequired,
        changeOrganizationCoordinator: PropTypes.func.isRequired,
        commonLimit: PropTypes.number,
        assignGlobalOperatingPartner: PropTypes.func.isRequired,
        unassignGlobalOperatingPartner: PropTypes.func.isRequired,
        getAvailableGlobalOperatingPartner: PropTypes.func.isRequired,
        getSubGlobalOperatingPartner: PropTypes.func.isRequired,
        getGlobalOperatingPartnerList: PropTypes.func.isRequired,
        getSubGlobalOperatingPartnerList: PropTypes.func.isRequired,
        setGlobalOperatingPartnerToOrgRegistration: PropTypes.func.isRequired,
        setOrganizationsSelected: PropTypes.func.isRequired,
        bulkSelectOrganizations: PropTypes.func.isRequired,
        selectableOrganizationIds: PropTypes.list,
        areAllOrganizationsSelected: PropTypes.list,
        getOrganizationClientCustomization: PropTypes.func.isRequired
      }

      static defaultProps = {
        params: {}
      }

      componentDidMount() {
        let { organizations } = this.props
        const { setOrganizationsParams, setOrganizationsFilter, commonLimit } = this.props

        let limit = config.defaultLimit || organizations.limit

        if (config.useCommonLimit && commonLimit) {
          organizations = {
            ...organizations,
            limit: commonLimit
          }
          setOrganizationsParams({ limit: commonLimit })
        }

        if (config.disableLimit) {
          limit = undefined
        }

        config.defaultLimit &&
        setOrganizationsParams({
          limit
        })

        config.detail && this.handleGetOrganization()
        config.myDetail && this.handleGetMyOrganization()
        config.leaders && this.handleOrganizationContacts(organizations.leaders)
        config.codeList && this.handleGetOrganizationCodeList()

        if (config.hasOwnProperty('organizationFilter')) {
          setOrganizationsFilter(config.organizationFilter)
        }
      }

      componentWillReceiveProps(nextProps) {
        const { organizations } = this.props
        const { filter, limit, offset, sort, invalidate } = nextProps.organizations
        const {
          filter: filterLeaders,
          limit: limitLeaders,
          offset: offsetLeaders,
          sort: sortLeaders,
          invalidate: invalidateLeaders
        } = nextProps.organizations.leaders

        if (
          organizations.filter !== filter ||
          organizations.limit !== limit ||
          organizations.offset !== offset ||
          organizations.sort !== sort ||
          organizations.invalidate !== invalidate
        ) {
          config.list &&
          this.handleGetOrganizations(
            nextProps.organizations,
            this.handleGetBaseFilter(),
            config.params,
            {
              isMinimal: config.minimal,
              includeInactive: config.includeInactive
            }
          )
        }

        if (
          organizations.leaders.filter !== filterLeaders ||
          organizations.leaders.limit !== limitLeaders ||
          organizations.leaders.offset !== offsetLeaders ||
          organizations.leaders.sort !== sortLeaders ||
          organizations.leaders.invalidate !== invalidateLeaders
        ) {
          config.leaders &&
          this.handleOrganizationContacts(nextProps.organizations.leaders)
        }
      }

      handleGetRootPath = pathname => pathname.split('/')[1]

      handleFetchOrganization = (
        {
          filterById,
          isMinimal,
          filterCase,
          parentNaoId,
          disableLimit,
          disablePaging,
          silentLoading,
          ignoreCount,
          ignorePage,
          resetFilter,
          assessor
        } = {}
      ) =>
        this.handleGetOrganizations(
          this.handleGetDefaultState(),
          this.handleGetBaseFilter(filterById, filterCase, { parentNaoId }),
          {
            params: config.params,
            disableRootQueryParams: config.disableRootQueryParams
          },
          {
            disableLimit,
            disablePaging: config.disablePaging || disablePaging,
            isMinimal: config.minimal || isMinimal,
            includeInactive: config.includeInactive,
            silentLoading,
            ignoreCount,
            ignorePage,
            resetFilter,
            assessor
          }
        )

      handleGetDefaultState = () => {
        const { organizations } = this.props

        const { commonLimit } = this.props

        let limit = config.defaultLimit || organizations.limit

        if (config.useCommonLimit && commonLimit) {
          limit = commonLimit
        }

        if (config.disableLimit) {
          limit = undefined
        }

        return {
          ...organizations,
          limit
        }
      }

      handleGetBaseFilter = (filterById, filterCase, { parentNaoId } = {}) => {
        const {
          decoFilter,
          params,
          leaders,
          organizations,
          decoOrganizationHierarchyLevel
        } = this.props

        const auOrIacId = ROLES.GBT.organizationId === Number(params.id)
          ? ORGANIZATION_HIERARCHY.IAC.id
          : ORGANIZATION_HIERARCHY.AU.id

        switch (filterCase || decoFilter || config.filter) {
          case 'awardUnits':
            return `organizationHierarchyLevel.id=${decoOrganizationHierarchyLevel || auOrIacId}`
          case 'organizationAwardUnits':
            return `flatHierarchy.parentOrganization.id=${params && params.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id}`
          case 'organizationOAs':
            return `flatHierarchy.parentOrganization.id=${params && params.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.OA.id}`
          case 'organizationSOAs':
            return `flatHierarchy.parentOrganization.id=${params && params.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.SOA.id}`
          case 'organizationICs':
            return `flatHierarchy.parentOrganization.id=${params && params.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IC.id}`
          case 'organizationIACs':
            return `flatHierarchy.parentOrganization.id=${params && params.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IAC.id}`
          case 'organizationSGOPs':
            return `flatHierarchy.parentOrganization.id=${params && params.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.SGOP.id}`
          case 'countryAwardUnits':
            return `country.id=${filterById},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id}`
          case 'countryAwardUnitsOrIacs':
            return `country.id=${filterById},or(hierarchyLevel.value=${ORGANIZATION_HIERARCHY.AU.value},hierarchyLevel.value=${ORGANIZATION_HIERARCHY.IAC.value})`
          case 'organizationAwardUnitsRegistrations':
            return `or(organization.flatHierarchy.parentOrganization.id=${params && params.id},organization.id=${params && params.id})`
          case 'NAOs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.NAO.id}`
          case 'GOPs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.GOP.id}`
          case 'SGOPs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.SGOP.id}`
          case 'ICs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IC.id}`
          case 'ROs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.RO.id}`
          case 'OAs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.OA.id}`
          case 'OrgOAs':
            return `parent.id=${filterById},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.OA.id}`
          case 'NaoOAs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.OA.id},parentNAO.id=${parentNaoId}`
          case 'SOAs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.SOA.id}`
          case 'OaSOAs':
            return `parent.id=${filterById},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.SOA.id}`
          case 'SGOPsAndGOPs':
            return `or(hierarchyLevel.value=${ORGANIZATION_HIERARCHY.SGOP.value},hierarchyLevel.value=${ORGANIZATION_HIERARCHY.GOP.value})`
          case 'IACs':
            return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IAC.id}`
          case 'awardUnitsOrIacs':
            return `or(organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IAC.id})`
          case 'sameParent':
            return `parent.id=${get(leaders, 'detail.organization.parent.id')}`
          case 'userOrgParent':
            return this.getFilterByActiveOrganization(organizations)
          case 'allOrgInStructureByCountry':
            return `country.id=${filterById},or(organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.NAO.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.OA.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.SOA.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IAC.id})`
          case 'allOrgInStructure':
            return `or(organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.NAO.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.OA.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.SOA.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IAC.id})`
          default:
            return ''
        }
      }

      handleGetOrganizations = (
        organizations,
        baseFilter,
        params,
        {
          disableLimit,
          disablePaging,
          isMinimal = false,
          includeInactive = false,
          silentLoading = false,
          ignoreCount = false,
          ignorePage = false,
          resetFilter = false,
          assessor = false
        } = {}
      ) =>
        this.props.getOrganizations(organizations, baseFilter, params, {
          isMinimal,
          disableLimit,
          disablePaging,
          includeInactive,
          silentLoading,
          ignoreCount,
          ignorePage,
          resetFilter,
          assessor
        })

      handleGetOrganizationCodeList = ({ filterById, filterCase, parentNaoId } = {}) => {
        this.props.getOrganizationCodeList(this.handleGetBaseFilter(filterById, filterCase, { parentNaoId }))
      }

      handleGetOrganization = () => {
        const { params } = this.props

        if (params.id) {
          this.props.getOrganization(params.id, config.params)
        }
      }

      handleReloadOrganization = () => {
        const { organisationId } = this.props

        if (organisationId) {
          this.props.getOrganization(organisationId, config.params)
        }
      }

      handleGetMyOrganization = () => {
        const { activeOrganization } = this.props

        if (activeOrganization.id) {
          this.props.getOrganization(activeOrganization.id, config.params)
        }
      }

      handleExportOrganizations = () => {
        const { organizations } = this.props

        return this.props
          .exportOrganizations(organizations, this.handleGetBaseFilter())
          .catch(this.handleError)
      }

      handleChangeAuthorizingContact = (id, fields) => {
        this.props
          .changeOrganizationAuthorizingContact(id, fields.contactId)
          .then(this.handleChangeContactSuccess)
          .catch(this.handleError)
      }

      handleChangeCoordinator = (id, fields) =>
        this.props
          .changeOrganizationCoordinator(id, fields.contactId)
          .then(async() => {
            if (fields.is_lead_coordinator) {
              await this.handleMakeLeadCoordinator(fields.contactId, id, fields)
            }

            this.handleChangeContactSuccess(
              'Coordinator has been set',
              'notifications.coordinator_has_been_set'
            )
          })
          .catch(this.handleError)

      handleRemoveCoordinator = (orgId, contactId) =>
        this.props
          .removeOrganizationCoordinator(orgId, contactId)
          .then(() =>
            this.handleChangeContactSuccess(
              'Coordinator has been removed',
              'notifications.coordinator_has_been_removed'
            )
          )
          .catch(this.handleError)

      handleMakeLeadCoordinator = (contactId, organizationId, fields) =>
        this.props
          .makeLeadCoordinator(contactId, organizationId, {
            isLeadCoordinator: fields.is_lead_coordinator
          })
          .then(async() =>
            this.handleChangeContactSuccess(
              'New Lead Coordinator has been set',
              'notifications.lead_coordinator_has_been_set'
            )
          )
          .catch(this.handleError)

      handleOrganizationContacts = leaders => {
        const { activeOrganization, decoOrganizationId } = this.props
        const organizationId = decoOrganizationId || activeOrganization.id

        if (config.disableLimit) {
          leaders.limit = undefined
        }

        if (activeOrganization.id) {
          !leaders.loading &&
          this.props.getOrganizationLeaders(
            organizationId,
            { leaders, sort: '+person.lastName' },
            config.excludeInactive && 'person.personState.value=ACTIVE'
          )
        }
      }

      handleGetOrganizationContacts = organizationId => {
         return this.props.getOrganizationLeaders(
              organizationId,
              { sort: '+person.lastName' },
              'person.personState.value=ACTIVE'
          )
      }

      handleAwardUnitCheck = ({ name, countryId }) => {
        if (name) {
          return this.props.checkOrganization(name, countryId)
        }

        return new Promise((res, rej) => rej())
      }

      handleUpdateOrganizationWithLogo = fields => {
        if (fields.file) {
          this.props
            .uploadImageBlob({
              file: fields.file
            })
            .then(({ body }) =>
              this.handleUpdateOrganization(fields, body.url, 'LOGO')
            )
            .catch(this.handleError)
        } else if (!fields.file && !fields.logoUrl) {
          this.handleUpdateOrganization(fields, null, 'LOGO')
        } else {
          this.handleUpdateOrganization(fields)
        }
      }

      handleUpdateOrganization = (fields, logoUrl, update) => {
        const { route } = this.props

        const sendFinData = [
          ORGANIZATION_HIERARCHY.NAO.id,
          ORGANIZATION_HIERARCHY.IAC.id
        ].includes(get(route, 'isTypeId'))

        if (sendFinData) {
          update = typeof update === 'string' && update.length
            ? `${update},FINANCIAL_DATA`
            : 'FINANCIAL_DATA'
        }

        return this.props
          .updateMyOrganization(
            fields.id,
            updateScheme(fields, logoUrl),
            update
          )
          .then(this.handleUpdateSubmit)
          .catch(this.handleError)
      }

      handleMoveOrganization = (data, fields = {}, opts) => {
        return this.props
          .updateMyOrganization(
            data.id,
            {
              id: data.id,
              parent: {
                id: fields.soaId || fields.oaId
              }
            },
            'ORGANIZATION_PARENT',
            {
              removeDefaultParams: true
            }
          )
          .then(() => this.handleMoveSubmit(opts))
          .catch(this.handleError)
      }

      handleSetGlobalOperatingPartnerToOrgRegistration = (awardUnitRegistrationId, gopId, sgopId) => {
        return this.props.setGlobalOperatingPartnerToOrgRegistration(awardUnitRegistrationId, gopId, sgopId)
            .then(() => {
              this.handleRefreshTasks()
              this.handleUpdateSubmit({})
            })
            .catch(this.handleError)
      }

      handleAssignGlobalOperatingPartner = (orgId, gopId, sgopId) => {
        return this.props.assignGlobalOperatingPartner(orgId, gopId, sgopId)
            .then(() => {
              this.handleReloadOrganization()
              this.handleUpdateSubmit({})
            })
            .catch(this.handleError)
      }

      handleUnassignGlobalOperatingPartner = orgId => {
        return this.props.unassignGlobalOperatingPartner(orgId)
            .then(() => {
              this.handleReloadOrganization()
              this.handleUpdateSubmit({})
            })
            .catch(this.handleError)
      }

      handleGetAvailableGlobalOperatingPartner = orgId => {
        return this.props.getAvailableGlobalOperatingPartner(orgId)
            .catch(this.handleError)
      }

      handleGetGlobalOperatingPartnerList = () => {
        return this.props.getGlobalOperatingPartnerList()
            .catch(this.handleError)
      }

      handleGetSubGlobalOperatingPartnerList = gopId => {
        return this.props.getSubGlobalOperatingPartnerList(gopId)
            .catch(this.handleError)
      }

      handleGetSubGlobalOperatingPartner = (orgId, gopId) => {
        return this.props.getSubGlobalOperatingPartner(orgId, gopId)
            .catch(this.handleError)
      }


      handleRemoveOrganization = orgId =>
        this.props
          .removeOrganization(orgId)
          .then(this.handleRemoveSuccess)
          .catch(this.handleError)

      handleChangeOrganisationMode = (orgId, fields = {}) =>
        this.props
          .changeOrganisationMode(orgId, {
            organizationMode: {
              value: get(fields, 'organizationMode.value')
            }
          })
          .then(this.handleUpdateSubmit)
          .catch(this.handleError)

      handleUpdateOrganizationState = (organizationId, fields) =>
        this.props
          .updateMyOrganization(
            organizationId,
            fields,
            'CHANGE_ORGANIZATION_STATE',
            { removeDefaultParams: true }
          )
          .then(this.handleUpdateSubmit)
          .catch(this.handleError)

      handleApproveAwardUnit = id =>
        this.props
          .approveAwardUnit(id, { approved: true })
          .then(this.handleApproveSuccess)
          .catch(this.handleError)

      handleReturnAwardUnit = (id, fields) =>
        this.props
          .approveAwardUnit(id, { approved: false, note: fields.note })
          .then(this.handleReturnSuccess)
          .catch(this.handleError)

      handleApproveSuccess = () => {
        this.props.notification('Award unit has been approved', {
          status: 'success',
          intlKey: 'notifications.award_unit_has_been_approved'
        })
        this.handleRefresh()
      }

      handleReturnSuccess = () => {
        this.props.notification('Award unit has been returned', {
          status: 'success',
          intlKey: 'notifications.award_unit_has_been_returned'
        })
        this.handleRefresh()
      }

      handleRemoveSuccess = () => {
        const { route } = this.props

        this.props.notification('Award unit has been removed', {
          status: 'success',
          intlKey: 'notifications.award_unit_has_been_removed'
        })
        this.props.modal(null)
        if (get(route, 'isIac')) {
          this.props.push(`${appConfig.publicPath}/independent-award-centres`)
        } else {
          this.props.push(`${appConfig.publicPath}/award-units`)
        }
      }

      handleChangeContactSuccess = (
        text = 'Authorization contact has been set',
        intlKey = 'notifications.authorization_contact_has_been_set'
      ) => {
        this.props.notification(text, {
          status: 'success',
          intlKey
        })
        this.props.modal(null)
        this.handleRefreshAfterUpdate()
        this.handleRefresh()
      }

      handleUpdateSubmit = () => {
        this.props.notification('Organization has been updated', {
          status: 'success',
          intlKey: 'notifications.organization_has_been_updated'
        })
        this.handleRefreshAfterUpdate()
      }

      handleMoveSubmit = opts => {
        this.props.notification('Organization has been moved', {
          status: 'success',
          intlKey: 'notifications.organization_has_been_moved'
        })
        this.handleRefreshAfterUpdate(opts)
      }

      handleSetOrganizationSelectedTo = (id, newVal) => {
        const ids = this.props.organizations.selectedIds || []
        const newIds = ids.filter(i => i !== id).concat(newVal ? [id] : [])

        this.props.setOrganizationsSelected(newIds)
      }

      handleRefreshAfterUpdate = (opts = {}) => {
        if (config.myDetail) {
          this.handleGetMyOrganization()
        } else if (config.detail || opts.updateDetail || config.updateDetail) {
          this.handleGetOrganization()
        }
        this.props.modal(null)
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      handleRefresh = () => {
        const { local, getTasksRegistrationAwardUnits } = this.props

        config.updateTasks &&
        getTasksRegistrationAwardUnits(
          local.tasks,
          this.handleGetBaseFilter()
        )

        this.props.getTasksOverview(null, {
          activeOrganizationId: this.props.activeOrganizationId,
          awardLeaderId: this.props.user.personId
        })

        if (config.updateTasks) {
          this.props.modal(null)
        }
      }

      handleRefreshTasks = () => {
        const { local, getTasksRegistrationAwardUnits } = this.props

        getTasksRegistrationAwardUnits(local.tasks, '')
      }

      getFilterByActiveOrganization(organizations) {
        const activeOrganization = get(organizations, 'detail')

        if (get(activeOrganization, 'hierarchyLevel.value') === 'IAF') {
          return `or(organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id},organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IAC.id})`
        }

        if (get(activeOrganization, 'hierarchyLevel.value') === 'NAO') {
          return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id},parentNAO.id=${activeOrganization.id}`
        }

        if (get(activeOrganization, 'hierarchyLevel.value') === 'RO') {
          return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.IAC.id}`
        }

        if (get(activeOrganization, 'hierarchyLevel.value') === 'OA') {
          return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id},parentOA.id=${activeOrganization.id}`
        }

        if (get(activeOrganization, 'hierarchyLevel.value') === 'SOA') {
          return `organizationHierarchyLevel.id=${ORGANIZATION_HIERARCHY.AU.id},parentSubOA.id=${activeOrganization.id}`
        }

        return 'parent.id=' + get(activeOrganization, 'parent.id')
      }

      handleGetOrganizationClientCustomization = id => {
        return this.props.getOrganizationClientCustomization(id)
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            checkOrganization={this.handleAwardUnitCheck}
            updateMyOrganization={this.handleUpdateOrganizationWithLogo}
            removeOrganization={this.handleRemoveOrganization}
            changeOrganisationMode={this.handleChangeOrganisationMode}
            updateOrganizationState={this.handleUpdateOrganizationState}
            moveOrganization={this.handleMoveOrganization}
            setGlobalOperatingPartnerToOrgRegistration={this.handleSetGlobalOperatingPartnerToOrgRegistration}
            assignGlobalOperatingPartner={this.handleAssignGlobalOperatingPartner}
            unassignGlobalOperatingPartner={this.handleUnassignGlobalOperatingPartner}
            getAvailableGlobalOperatingPartner={this.handleGetAvailableGlobalOperatingPartner}
            getGlobalOperatingPartnerList={this.handleGetGlobalOperatingPartnerList}
            getSubGlobalOperatingPartnerList={this.handleGetSubGlobalOperatingPartnerList}
            getSubGlobalOperatingPartner={this.handleGetSubGlobalOperatingPartner}
            exportOrganizations={this.handleExportOrganizations}
            approveAwardUnit={this.handleApproveAwardUnit}
            returnAwardUnit={this.handleReturnAwardUnit}
            reloadOrganizationDetail={this.handleGetMyOrganization}
            getOrganizations={this.handleFetchOrganization}
            getOrganizationCodeList={this.handleGetOrganizationCodeList}
            onChangeAuthorizingContact={this.handleChangeAuthorizingContact}
            onChangeCoordinator={this.handleChangeCoordinator}
            onRemoveCoordinator={this.handleRemoveCoordinator}
            onMakeLeadCoordinator={this.handleMakeLeadCoordinator}
            onGetOrganizationContacts={this.handleGetOrganizationContacts}
            getCustomOrganizations={(customList, baseFilter, params, options) =>
              this.handleGetOrganizations(customList, baseFilter, params, options)}
            setOrganizationSelectedTo={this.handleSetOrganizationSelectedTo}
            onGetOrganizationClientCustomization={this.handleGetOrganizationClientCustomization}
          />
        )
      }
    }

    return enhance(Organizations)
  }
}

export default decorator
